module.exports = __webpack_public_path__ + "img/Fill38@2x.2ad9af86.png";